<template>
  <div class="container">
    <div class="top_title">学员二维码</div>
    <div class="scroll_area" style="overflow-y: auto">
      <div class="selection_condition_title" style="margin-top: 2.6rem">
        <span class="icon_selection_condition"></span>
        <span>筛选条件</span>
      </div>
      <div class="selection_items">
        <div class="weui-cells item">
          <div class="weui-cell weui-cell_select weui-cell_select-after">
            <div class="weui-cell__bd">
              <p>校区</p>
            </div>
            <div class="weui-cell__ft">
              <select class="weui-select" style="color:#bbb" v-model="currentSchool">
                <option value=''>请选择</option>
                <option v-for="school in schoolList" :value='school.I_SCHOOL_NO'>{{school.I_SCHOOL_NAME}}</option>
              </select>
            </div>
          </div>
          <div class="weui-cell weui-cell_select weui-cell_select-after">
            <div class="weui-cell__bd">
              <p>班级</p>
            </div>
            <div class="weui-cell__ft">
              <select class="weui-select" style="color:#bbb" v-model="currentClass">
                <option value=''>请选择</option>
                <option v-for="item in classList" :value='item.I_CLASS_NO'>{{item.I_CLASS_NAME}}</option>
              </select>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>姓名</p>
            </div>
            <div class="weui-cell__ft">
              <input type="text" class="input_text" v-model="I_STUDENT_NAME" placeholder="请输入学员姓名"/>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>手机</p>
            </div>
            <div class="weui-cell__ft">
              <input type="text" class="input_text" v-model="I_TEL" placeholder="请输入家长的手机号码" />
            </div>
          </div>

          <button class="bottom_btn" @click="search">查询</button>
        </div>
      </div>

      <div v-if="info.dataCount != '0'" class="students_list_title">
        <span class="icon_students_list"></span>
        <span>学员</span>
      </div>
      <div v-if="info.dataCount != '0'" class="students_list">
        <div class="weui-cells item">
          <div v-for="item in info.dataList" :key="item.id" @click="clickQrCode(item)"
                       class="weui-cell weui-cell_select weui-cell_select-after">
            <div class="weui-cell__bd">
              <p>{{item.I_STUDENT_NAME}}</p>
            </div>
            <div class="weui-cell__ft">
              <input type="text" class="input_text" disabled :value="item.I_TEL"/>
              <span class="icon_QRcode"></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--底部导航-->
    <Footer :navs="nav"></Footer>
  </div>
</template>

<script>
  import DataRequestFactory from '@/factories/dataRequestFactory.js'
  import Footer from '../components/Footer.vue'
  import weui from 'weui.js'
  export default {
    name: '',
    data () {
      return {
        nav: {
          sy: true,
          jchd: false,
          yyst: false,
          wd: false,
        },
        schoolList: [],
        currentSchool: "",
        classList: [],
        currentClass: "",
        I_STUDENT_NAME: "",
        I_TEL: "",
        info: {
          dataCount: "0",
          dataList:[]
        }
      }
    },
    components: {
      Footer
    },
    created() {
      let vm = this
      DataRequestFactory.C010010().then((response) => {
        vm.schoolList = response.dataList

        let pageNo = vm.$route.params.pageNo
        if(pageNo && pageNo == 'H300020') {
          if(window.localStorage.getItem("H300010Info")) {
            let H300010Info = JSON.parse(window.localStorage.getItem("H300010Info"))
            vm.currentSchool = H300010Info.I_SCHOOL_NO
            vm.currentClass = H300010Info.I_CLASS_NO
            vm.I_STUDENT_NAME = H300010Info.I_STUDENT_NAME
            vm.I_TEL = H300010Info.I_TEL

            vm.search();
          }
        }
      })
    },
    methods: {
      search() {
        let params = {
          I_SCHOOL_NO: this.currentSchool,
          I_CLASS_NO: this.currentClass,
          I_STUDENT_NAME: this.I_STUDENT_NAME,
          I_TEL: this.I_TEL,
        }

        window.localStorage.setItem("H300010Info",JSON.stringify(params))

        DataRequestFactory.I300010(params).then((response) => {
          this.info = response
      })
      },
      clickQrCode(item) {
        let params = {
          "I_SCHOOL_NO": item.I_SCHOOL_NO,
          "I_CLASS_NO": item.I_CLASS_NO,
          "I_STUDENT_NO": item.I_STUDENT_NO
        }

        this.$router.push({name:'H300020', params:{info: JSON.stringify(params)}})
      }
    },
    mounted() {
      let screenHeight = window.innerHeight;
      let fontSize = getComputedStyle(window.document.documentElement)['font-size']
      let heightDiff = screenHeight - parseInt(fontSize) * 0
      $(".scroll_area").css("height", heightDiff + "px"   )
    },
    watch: {
      currentSchool (val) {
        if(val == "") {
          this.classList = []
        } else {
          let param = {
            I_SCHOOL_NO: val
          }
          DataRequestFactory.C010011(param).then((response) => {
            this.classList = response.dataList
        })
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../assets/css/pages/H300010.css';
  @import '../assets/css/common.css';
</style>



// WEBPACK FOOTER //
// src/pages/H300010.vue